<template>
  <div class="layout-with-centered-max-width-child">
    <div>
      <div>
        <div v-if="loading">
          <Loading></Loading>
        </div>
        <div v-else-if="loaded">
          <div class="participants-container">
            <div class="heading-container">
              <span class="font-secondary heading">Manage Participants</span>
            </div>
            <div class="add-new-participants">
              <div class="left">
                Add New Participant:
              </div>
              <div class="left">
                <input v-model="newParticipant.email"
                       v-bind:class="{error: this.newParticipantFormInvalid}"
                       v-on:focus="resetFormError"
                       placeholder="Email">
              </div>
              <div class="left">
                <input v-model="newParticipant.name" placeholder="Name (Optional)">
              </div>
              <div class="left" v-on:click="addNewParticipant">
                <Fai v-if="addPristine" class="add-button" :icon="['far', 'plus-circle']"/>
                <Loading v-if="addLoading" class="loading-symbol"></Loading>
                <span v-if="addSent" class="added-notification">Added!</span>
                <span v-if="addError" class="added-error">Error!</span>
              </div>
            </div>
            <div v-if="areParticipantsEmpty">
              <div class="content">
                <div>
                  <span>It appears this study has no participants.</span>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="participants">
                <div v-for="participant in allParticipants" >
                  <div>
                    <div class="participant">
                      <div class="left">
                        <div class="check-icon-container">
                          <div v-if="surveyNotCompleted(participant)"></div>
                          <Fai v-else class="check-icon" :icon="['fas', 'check']"/>
                        </div>
                        <div>
                          <div class="name">
                              <span>{{participant.name}}</span>
                          </div>
                          <div class="email">
                            <span>{{participant.email}}</span>
                          </div>
                        </div>
                      </div>
                      <div class="right">
                        <div v-if="surveyNotCompleted(participant)" >
                          <div v-if="reminderPristine(participant.loadingStatus)">
                            <button class="button" v-on:click="sendReminder(participant)" >Send a Reminder</button>
                          </div>
                          <div v-if="reminderLoading(participant.loadingStatus)" style="margin-right: 4em">
                            <Loading></Loading>
                          </div>
                          <div v-if="reminderSent(participant.loadingStatus)" style="margin-right: 4em">
                            <span class="sent-notification font-secondary">Sent!</span>
                          </div>
                          <div v-if="expired(participant.loadingStatus)" style="margin-right: 4em">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="failedToLoad">
          <ErrorPage>
            <div slot="header">ERROR</div>
            <div slot="message">Sorry, there was an error loading the page</div>
          </ErrorPage>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    GET_BACKEND_URL, GET_HTTP_CONFIG,
    LOADING_COMPLETED_FAILURE,
    LOADING_COMPLETED_SUCCESS,
    LOADING_PRISTINE,
    LOADING_STARTED
  } from "../../services/constants"
  import ErrorPage from "./ErrorPage"
  import http from "../../services/axios"

    export default {
      name: "ManageParticipants",
      components: {ErrorPage},
      created() {
        this.updateStudies()
      },

      data(){
        return{
          loadingStatus: LOADING_STARTED,
          participants: [],
          newParticipant: this.newPartipantFormModel(),
          newParticipantFormInvalid: false,
          emailButtonLoadingStates: [],
          addButtonLoadingState: LOADING_PRISTINE,
        }
      },

      computed:{
        loading(){
          return this.loadingStatus === LOADING_STARTED
        },
        loaded(){
          return this.loadingStatus === LOADING_COMPLETED_SUCCESS
        },
        failedToLoad(){
          return this.loadingStatus === LOADING_COMPLETED_FAILURE
        },
        studyState() {
          return this.studyInfo.loadingState
        },
        studyData() {
          return this.studyInfo.data
        },
        studyInfo(){
          return this.$store.state.dataModule.getStudyState
        },
        areParticipantsEmpty(){
          return this.allParticipants.length === 0
        },
        allParticipants(){
          let x = []
          for (let [index, value] of this.participants.entries()) {
            let participant = Object.assign({}, value)
            participant['loadingStatus'] = this.emailButtonLoadingStates[index].loadingStatus
            console.log()
            if(participant.email && participant.email.includes("@")){
              x.push(participant)
            }
          }
          return x

        },
        addPristine(){
          return this.addButtonLoadingState === LOADING_PRISTINE
        },
        addLoading(){
          return this.addButtonLoadingState === LOADING_STARTED
        },
        addSent(){
          return this.addButtonLoadingState === LOADING_COMPLETED_SUCCESS
        },
        addError(){
          return this.addButtonLoadingState === LOADING_COMPLETED_FAILURE
        },
      },

      methods:{
        surveyNotCompleted(participant){
          return !participant.completedStudy
        },
        updateEmailLoadingStatus(id, status){
          this.emailButtonLoadingStates = this.emailButtonLoadingStates.map(state => {
            if(state.id === id){
              state.loadingStatus = status
              setTimeout(() => { state.loadingStatus = null }, 2000);
            }
            return state
          })
        },
        sendReminder(participant){
          this.updateEmailLoadingStatus(participant.id, LOADING_STARTED)
          http.post(this.$store.getters[GET_BACKEND_URL](`mail/participants/${participant.id}/reminder`), {}, this.$store.getters[GET_HTTP_CONFIG]).then(response => {
            this.updateEmailLoadingStatus(participant.id, LOADING_COMPLETED_SUCCESS)
          })
        },
        addNewParticipant(){
          if(this.newParticipantValid()){
            this.addButtonLoadingState = LOADING_STARTED
            http.post(this.$store.getters[GET_BACKEND_URL](`studies/${this.$route.params.id}/participants`), this.newParticipant, this.$store.getters[GET_HTTP_CONFIG]).then(response => {
              this.updateStudies()
              this.addButtonLoadingState = LOADING_COMPLETED_SUCCESS
              this.newParticipant = this.newPartipantFormModel()
              setTimeout(() => { this.addButtonLoadingState = LOADING_PRISTINE }, 2000);
            })
              .catch(err => {
                this.addButtonLoadingState = LOADING_COMPLETED_FAILURE
                setTimeout(() => { this.addButtonLoadingState = LOADING_PRISTINE }, 2000);
              })
          }
          else{
            this.newParticipantFormInvalid = true
          }
        },
        newPartipantFormModel(){
          return {
            name: '',
            email: '',
          }
        },
        newParticipantValid(){
          return this.newParticipant.email.length > 0
        },
        resetFormError(){
          this.newParticipantFormInvalid = false
        },
        setButtonLoadingStates(participants){
          for (let i = this.emailButtonLoadingStates.length; i < participants.length; i++) {
            this.emailButtonLoadingStates.push({id: participants[i].id, loadingStatus: LOADING_PRISTINE})
          }
        },
        updateStudies(){
          http.get(this.$store.getters[GET_BACKEND_URL](`studies/${this.$route.params.id}/participants`), this.$store.getters[GET_HTTP_CONFIG]).then(response => {
            this.participants = response.data
            this.setButtonLoadingStates(response.data)
            this.loadingStatus = LOADING_COMPLETED_SUCCESS
          })
          .catch(err => {
            console.error(err)
            this.loadingStatus = LOADING_COMPLETED_FAILURE
          })
        },
        reminderPristine(status){
          return status === LOADING_PRISTINE
        },
        reminderLoading(status){
          return status === LOADING_STARTED
        },
        reminderSent(status){
          return status === LOADING_COMPLETED_SUCCESS
        },
        expired(status){
          return status === null
        },
      },

    }
</script>

<style scoped lang="scss">
  @import "../../scss/main";

  .heading-container{
    padding: 2em 0 0 0;
  }

  .heading{
    color: $red-2;
    font-size: 20pt;
  }

  .participants-container{
    padding: 0 2em;
  }

  .add-new-participants{
    padding: 3em 0 0 0;
    display: flex;

    .left{
      justify-content: flex-start;
      margin-right: 1em;

      input {
        border: 0;
        outline: 0;
        border-bottom: 1px solid $gray-2;
      }

      .error{
        border-bottom: 1px solid red;
        color: red;
      }

      .error::placeholder{
        color: red;
      }
      .add-button{
        color: $red-2;
        font-size: 200%;
        padding-left: 1em;
        cursor: pointer;
      }
      .loading-symbol{
        color: $red-2;
        padding-left: 1em;
      }
      .added-notification{
        color: $red-2;
        padding-left: 1em;
      }
      .added-error{
        color: $red-2;
        padding-left: 1em;
      }

    }
  }

  .content {
    padding: 2em 0;
  }

  .participants {
    padding: 1em 0 5em 0;
  }

  .participant {
    display: flex;
    border-bottom: 1px solid $red-2;
    padding: 20px 0;

    .left {
      display: flex;
      justify-content: flex-start;
      flex-grow: 1;

      .check-icon-container{
        width: 7em;
        text-align: center;
      }

      .name{
        font-size: large;
        min-height: 16px;
      }

      .email{
        font-size: small;
      }

      .check-icon{
        color: $cyan-1;
        font-size: 150%;
      }
    }

    .right {
      display: flex;
      justify-content: flex-end;

      .button{
        border-color: $red-2;
        font-weight: bold;
        background-color: $white-1;
        border-width: medium;
        color: $red-2;
        border-radius: 5px;
        padding: 10px 20px;
      }

      .sent-notification{
        color: $red-2;
        vertical-align: center;
        justify-content: center;
        font-size: 150%;
      }

    }
  }




</style>
